import styled from 'styled-components';

export const ContentWrapper = styled.div`
  display: flex;
  gap: 10px;
`;
